import React, { useState } from "react";
import styles from "./SupervisorOverview.module.css";
import TextComponent from "../../../../../../components/textComponent/TextComponent";
import { Image } from "antd";



const OverviewComponent = () => {
    const Data1 = {
        "Product_Tag": "French Bread",
        "Category": "Component",
        "SKU_Code": "24569",
        "Quantity": "36 oz",
        "Shelf-life (Days)": "180",
    };
    const Data2 = {
        "Description": "light and airy with a thin crispy crust",
        "Finished weight": "528g",
        "Finished Dimensions": "20 x 10 x 9 cm",
        "Final Color": "ffffff White",
        "Texture": "light interior, crispy crust",
        "Batch Weight": "200 ",
        "Quantity per Batch": "250",
        "QC Check ": [
            "https://media.istockphoto.com/id/518468635/photo/french-pastries-on-display-a-confectionery-shop.jpg?s=612x612&w=0&k=20&c=av7rYRCLckvDp6s9sGmA_S9Lp_fTSDSSOtmR0wWJ8nY=",
            "https://images.unsplash.com/photo-1608198093002-ad4e005484ec?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmFrZXJ5JTIwcHJvZHVjdHN8ZW58MHx8MHx8fDA%3D&fm=jpg&q=60&w=3000",
            "https://img.freepik.com/free-photo/sweet-pastry-assortment-top-view_23-2148516578.jpg",
        ],
    };
    return (
        <div className={styles.mainCont}>
            <TextComponent className={styles.Heading} text={"Product  Detail"} />
            <div className={styles.itemsList}>
                {Object.entries(Data1).map(([label, value]) => {
                    const formattedLabel = label.replace(/_/g, " ");
                    return (
                        <div className={styles.row}>
                            <TextComponent className={styles.label} text={`${formattedLabel} :`} />
                            <TextComponent className={styles.value} text={value || "-"} />

                        </div>
                    );
                })}
            </div>

            <TextComponent className={styles.Heading} text={"FINISHED PRODUCT SPECIFICATIONS"} />
            <div className={styles.itemsList}>
                {Object.entries(Data2).map(([label, value]) => {
                    const formattedLabel = label.replace(/_/g, " ");
                    return (
                        <div className={styles.row}>
                            <TextComponent className={styles.label} text={`${formattedLabel} :`} />
                            {Array.isArray(value) ? (
                                <Image.PreviewGroup>
                                    <div className={styles.images}>
                                        {value.map((imgSrc, idx) => (
                                            <Image className={styles.qc_image} key={idx} width={80} src={imgSrc} alt={`${label}-${idx}`} />
                                        ))}
                                    </div>
                                </Image.PreviewGroup>
                            ) : (
                                <TextComponent className={styles.value} text={value || "-"} />
                            )}

                        </div>
                    );
                })}
            </div>

        </div>
    );
};

export default OverviewComponent;
